module.exports = __webpack_public_path__ + "img/user.7d5fe157.png";